import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Chip, Rating } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import veg from "../../Assets/FoodType/veg.png";
import nonVeg from "../../Assets/FoodType/non-veg.png";

const RecipeHeader = ({ recipe, authorName, ratingCount, averageRating }) => {
  const theme = useTheme();

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      mb: theme.spacing(2),
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[1],
      p: 2,
      flexDirection: { xs: 'column', sm: 'row' },
      gap: { xs: 2, sm: 0 }
    }}>
      <Box sx={{ flex: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <img
            src={recipe?.recipe_type === 'Veg' ? veg : nonVeg}
            alt="Food type"
            style={{ width: 50, height: 50, marginRight: theme.spacing(1) }}
          />
          <Typography variant="h4" sx={{
            fontWeight: 'bold',
            color: theme.palette.primary.main,
            fontSize: { xs: '1.5rem', sm: '2rem' }
          }}>
            {recipe?.recipe_name}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
          <Rating value={averageRating} readOnly size="small" />
          <Chip
            label={`${averageRating} Stars`}
            sx={{ mx: 1, bgcolor: theme.palette.primary.main, color: 'white' }}
          />
          <Typography variant="body2" color="text.secondary">
            ({ratingCount} users)
          </Typography>
        </Box>
      </Box>
      
      <Box sx={{ flex: 1, textAlign: { xs: 'left', sm: 'right' } }}>
        <Typography variant="body2" color="text.secondary">
          Submitted by: {authorName}
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={1}>
          Updated: {new Date(recipe?.modified).toLocaleDateString()}
        </Typography>
      </Box>
    </Box>
  );
};
RecipeHeader.propTypes = {
  recipe: PropTypes.object,
  authorName: PropTypes.string,
  ratingCount: PropTypes.number,
  averageRating: PropTypes.number
};

export default RecipeHeader;
